import React from 'react';
import { METRIC_NAME } from '@/pages/home/pages/home/components/DataSource/_config/metricName';
// import { DataSourceIcon } from '@/pages/home/pages/home/components/DataSource';
import { useIntl, history } from 'umi';
import { datamapIntelligenceMetricsPath } from '@/pages/home/utils/urlConfig';
import { getDataSourceIcon } from '@/pages/intelligence/utils/getDataSourceImg';

const clickLearnMore = (metric: string, metricKey = '', entityType = '') => {
  history.push({
    pathname: datamapIntelligenceMetricsPath,
    query: {
      pageid: metric === 'newzoo' ? 'ogdb' : metric,
      metric: metricKey || '',
      gameType: entityType || '',
    },
  });
};
export type DataSourceMetricType =
  | 'appannie'
  | 'appstore'
  | 'bilibili'
  | 'crunchbase'
  | 'databarin'
  | 'epic'
  | 'fbgaming'
  | 'googleplay'
  | 'hatchet'
  | 'mscience'
  | 'newzoo'
  | 'nintendo'
  | 'npd'
  | 'playstation'
  | 'sensortower'
  | 'steam'
  | 'taptap'
  | 'twitch'
  | 'xbox'
  | 'youtube';

interface PropsType {
  metric: DataSourceMetricType;
  sourceNameLocalId: string;
  metricKey?: string;
  entityType?: string;
}

// 迁移DataSourceBubbleContent组件，后续重构MarketProfile时，换成情报公共组件
export const DataSourceBubbleContent = (props: PropsType) => {
  const { formatMessage } = useIntl(); // 中英切换方法
  const { metric, sourceNameLocalId, metricKey = '', entityType = '' } = props;
  return (
    <span>
      {formatMessage(
        {
          id: metric === 'newzoo' ? 'dbi_metric_dataof_generatedby' : 'dbh_metric_dataof_comesfrom',
        },
        {
          sourceName: sourceNameLocalId,
        },
      )}
      {/* <DataSourceIcon className="datasource-comp-sourcessicon" type={metric} /> */}
      <img src={getDataSourceIcon(metric)} className="dbi-pcGame-select-icon" />
      {metric === 'newzoo' ? 'No-update' : METRIC_NAME[metric]}
      {metric === 'newzoo' ? formatMessage({ id: 'dbi_metric_dataof_generatedby_suf' }) : ''}

      <span
        style={{ color: '#0076FF', paddingLeft: '5px', cursor: 'pointer' }}
        onClick={() => {
          clickLearnMore(metric, metricKey, entityType);
        }}
      >
        {formatMessage({ id: 'dbh_learnmore' })}
      </span>
    </span>
  );
};
